// extracted by mini-css-extract-plugin
export default {"nextButton":"ShowMore_nextButton__h8Cau","glyph":"ShowMore_glyph__rf0kM"};